import Demo from './table.vue';

export default Demo;
